module.exports = __webpack_public_path__ + "img/map_BG-Web.e37bbfb9.png";